import { render, staticRenderFns } from "./tmbMsi.vue?vue&type=template&id=33ac7e36&scoped=true"
import script from "./tmbMsi.vue?vue&type=script&lang=js"
export * from "./tmbMsi.vue?vue&type=script&lang=js"
import style0 from "./tmbMsi.vue?vue&type=style&index=0&id=33ac7e36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac7e36",
  null
  
)

export default component.exports